/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsMinimize: {
  name: 'arrows-minimize';
  data: string;
} = {
  name: 'arrows-minimize',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.707 3.293a1 1 0 1 0-1.414 1.414L6.586 8H4a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v2.586L4.707 3.293Zm16 1.414a1 1 0 0 0-1.414-1.414L16 6.586V4a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-2.586l3.293-3.293ZM3 15a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.586l-3.293 3.293a1 1 0 0 1-1.414-1.414L6.586 16H4a1 1 0 0 1-1-1Zm12-1a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-2.586l3.293 3.293a1 1 0 0 0 1.414-1.414L17.414 16H20a1 1 0 1 0 0-2h-5Z" fill="currentColor"/></svg>`,
};
